import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const ReportData = (props) => {
  return (
    <div>
      <div className="text text-center text-secondary fw-bolder h3">
        {props.head}
        <hr />
      </div>
      <LineChart
        width={500}
        height={300}
        data={props.data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="client_name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey={props.dataKey}
          stroke={props.color}
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </div>
  );
};

export default ReportData;
